import { scroll, animate } from "motion";

const initWordScrollEffect = (selector = ".wysiwyg__content") => {
    const containers = document.querySelectorAll(selector);
    if (!containers.length) return;

    containers.forEach((container) => processContainer(container));
};

const processContainer = (container) => {
    wrapWordsInSpans(container);

    const words = container.querySelectorAll(".word-span");
    if (!words.length) return;

    scroll(
        (progressParam) => {
            const progress =
                typeof progressParam === "object" && progressParam?.y
                    ? progressParam.y.progress
                    : progressParam;

            const totalWords = words.length;
            const scrollY = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const containerRect = container.getBoundingClientRect();

            let finalActiveWords = Math.floor(progress * totalWords);

            if (progress >= 0.999) {
                finalActiveWords = totalWords;
            } else {
                const isContainerVisible =
                    containerRect.bottom > 0 && containerRect.top < windowHeight;
                const isNearBottom = scrollY + windowHeight >= documentHeight - 20;

                if (isNearBottom && isContainerVisible) {
                    finalActiveWords = totalWords;
                } else {
                    const isPastViewport = containerRect.top < windowHeight * 0.3;
                    if (progress > 0.9 && isPastViewport) {
                        finalActiveWords = totalWords;
                    }
                }
            }

            words.forEach((word, index) => {
                const isActive = index < finalActiveWords;
                animate(
                    word,
                    {
                        color: isActive ? "var(--color-white)" : "var(--color-tiertary-text)",
                        opacity: isActive ? 1 : 0.5,
                    },
                    {
                        duration: isActive ? 0.3 : 0.2,
                        ease: "easeOut",
                    }
                );
            });
        },
        {
            target: container,
            offset: ["start 0.75", "end 0.75"],
        }
    );
};

const wrapWordsInSpans = (element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
            const parent = node.parentElement;
            if (!parent || ["SCRIPT", "STYLE"].includes(parent.tagName))
                return NodeFilter.FILTER_REJECT;
            if (parent.classList.contains("word-span")) return NodeFilter.FILTER_REJECT;
            return node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        },
    });

    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
        textNodes.push(node);
    }

    textNodes.forEach((textNode) => {
        const words = textNode.textContent.split(/(\s+)/);
        const fragment = document.createDocumentFragment();

        words.forEach((word) => {
            if (word.trim()) {
                const span = document.createElement("span");
                span.classList.add("word-span");
                span.textContent = word;
                span.style.color = "var(--color-tiertary-text)";
                span.style.opacity = "0.5";
                fragment.appendChild(span);
            } else {
                fragment.appendChild(document.createTextNode(word));
            }
        });

        textNode.parentNode?.replaceChild(fragment, textNode);
    });
};

document.addEventListener("DOMContentLoaded", () => {
    initWordScrollEffect(".animate-words");
});
